import React from 'react';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import FileSaver from 'file-saver';
import { FileEarmarkSpreadsheet } from 'react-bootstrap-icons';
import Tooltip from '@mui/material/Tooltip';

class PrintRefExcel extends React.Component {

    constructor(props) {
        super(props)
        // this.state = { click: 0 }
        this.getExcelData = this.getExcelData.bind(this);
    };

    async getExcelData() {
        if (this.props.pdfPrintData.length > 0) {
            const requestOpt = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({data: this.props.pdfPrintData, language: localStorage.getItem('language')})
            };

            await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/excelData?excelData`, requestOpt)
                .then(async response => {
                    const blob = await response.blob();
                    FileSaver.saveAs(blob, 'References.xlsx');
                })
        } else {
            const requestOpt = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({data: this.props.referencesData.data, language: localStorage.getItem('language')})
            };

            await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/viewRef/excelData?excelData`, requestOpt)
                .then(async response => {
                    const blob = await response.blob();
                    FileSaver.saveAs(blob, 'References.xlsx');
                })
        }
    }


    render() {

        return (
            <div>
                  <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Print Excel</h6>}>
                <Button
                    // backgroundColor: 'rgba(19, 174, 236, 0.54)'
                    style={{  width: 80, backgroundColor: 'rgba(0, 128, 0, 0.54)', marginBottom: 10, marginTop: 5 }}
                    onClick={this.getExcelData}
                    variant="contained"
                    size="large"
                    color="primary"
                    startIcon={<FileEarmarkSpreadsheet style={{ color: 'white' }} />}
                >
                </Button>
                </Tooltip>
            </div>
        );
    }
}

const mapStateToProps = state => {

    return {
        pdfPrintData: state.showRefState.pdfPrintData,
        referencesData: state.searchRefState.referencesData
    }
}

export default connect(mapStateToProps, null)(PrintRefExcel);